import { Component } from "react";
import Constants from "../utils/Constants";
import RoutePath from "../utils/routes/RoutePath";
import '@google/model-viewer/dist/model-viewer'
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Actions from "../redux/actions";
import { connect } from "react-redux";
import Select from 'react-select';

class AddRoomService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vendorRoomListData: ''
        }
    }

    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "products" && Agent[1] === "admin") {
            this.setState({ isVendor: true })
        } else {
            this.setState({ isVendor: false })
        }
        this.getVendorAllServiceList()
        this.getVendorAllRoomList()
        this.props.getVendorWardList({}, () => { });
        if (this.props.value?.srmIpWardId) {
            this.getVendorAllSrmIpAgentList(this.props.value.srmIpWardId)
        }
    }

    componentDidUpdate(prevProps) {
        const prevWardId = prevProps.value?.srmIpWardId;
        const nextWardId = this.props.value?.srmIpWardId;
        if (nextWardId && Number(nextWardId) !== Number(prevWardId)) {
            this.getVendorAllSrmIpAgentList(nextWardId);
        }
    }

    getVendorAllServiceList = () => {
        let params = {}
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.getVendorServiceList(params, callback)
    }

    getVendorAllRoomList = () => {
        let params = {}
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems, vendorRoomListData: response?.response })
            }
        }
        this.props.getRoomList(params, callback)
    }

    getVendorAllSrmIpAgentList = (wardId) => {
        let params = {
            agentRoleFilter: 'room_nurse',
        }
        if (wardId) {
            params.srmIpWardId = wardId;
        }
        this.props.getVendorSrmIpAgentList(params, () => { })
    }

    render() {
        const { isEdit, handleSubmit, handleWardName, handleRoomName, handleServiceName, handleAgentName, value, message, error } = this.props
        const { getVendorRoomService = {} } = this.props
        const { vendorRoomListData } = this.state
        const { vendorServiceListData, vendorSrmIpAgentListData, vendorWardListData } = getVendorRoomService
        const selectedWardId = value?.srmIpWardId ? Number(value.srmIpWardId) : null
        const allRooms = vendorRoomListData?.rooms || []
        const roomsForWard = selectedWardId
            ? allRooms.filter((room) => Number(room?.srmIpWardId) === selectedWardId)
            : []
        const patientOptions =
            vendorSrmIpAgentListData?.srmVendorSeviceAgents?.map((o) => ({
                value: o?.User?.id,
                label: `${o?.User?.fullName} (${o?.User?.email})`,
            })) || [];
        const roomOptions =
            roomsForWard.map((room) => ({
                value: room?.id,
                label: room?.patientRoomName,
            })) || [];
        const serviceOptions =
            vendorServiceListData?.services?.map((service) => ({
                value: service?.id,
                label: service?.serviceName,
            })) || [];
        const wardOptions =
            (vendorWardListData?.wards || []).map((ward) => ({
                value: ward?.id,
                label: ward?.wardName,
            })) || [];
        return (
            <div className="content-part px-5 py-4">
                <div className="agent-details h-100">
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Ward</p>
                                <Select
                                    options={wardOptions}
                                    value={wardOptions?.find((opt) => Number(opt?.value) === selectedWardId) || null}
                                    onChange={(selectedOption) => handleWardName(selectedOption)}
                                    isClearable={!isEdit}
                                    isSearchable
                                    placeholder="Select Ward"
                                    isDisabled={!!isEdit}
                                />
                                {error?.srmIpWardId && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.srmIpWardId}</span>}
                            </div>
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Room Name</p>
                                <Select
                                    options={roomOptions}
                                    value={roomOptions?.find((opt) => opt?.value === value?.srmIpRoomId) || null}
                                    onChange={(selectedOption) => handleRoomName(selectedOption)}
                                    isClearable
                                    isSearchable
                                    placeholder={selectedWardId ? "Select Room" : "Select Ward first"}
                                    isDisabled={isEdit || !selectedWardId}
                                />
                                {error?.srmIpRoomId && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.srmIpRoomId}</span>}
                            </div>
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Service Name</p>
                                <Select
                                    options={serviceOptions}
                                    value={serviceOptions?.find((opt) => opt?.value === value?.srmIpServiceId) || null}
                                    onChange={(selectedOption) => handleServiceName(selectedOption)}
                                    isClearable
                                    isSearchable
                                    placeholder="Select Service"
                                />
                                {error?.srmIpServiceId && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.srmIpServiceId}</span>}
                            </div>
                        </div>

                    </div>
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Room Nurse</p>
                                <Select
                                    options={patientOptions}
                                    value={patientOptions?.find((opt) => opt?.value === value?.userId) || null}
                                    onChange={(selectedOption) => handleAgentName(selectedOption)}
                                    isClearable
                                    placeholder={selectedWardId ? "Select Room Nurse" : "Select Ward first"}
                                    isSearchable
                                    isDisabled={!selectedWardId}
                                />
                                {error?.userId && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.userId}</span>}
                            </div>
                        </div>

                    </div>
                    <div className="mt-5 me-5 d-flex justify-content-start">
                        <button type="button" className="btn input-btn" onClick={() => this.props.history.push(RoutePath.VENDOR_ROOM_SERVICE)}>{Constants.BACK}</button>
                        <button type="button" className="btn input-btn mx-3" onClick={() => handleSubmit()}>{isEdit ? Constants.UPDATE : Constants.CREATE}</button>
                    </div>
                </div>
            </div>
        )
    }
}
export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVendorServiceList: Actions.getVendorServiceList,
    getRoomList: Actions.getRoomList,
    getVendorSrmIpAgentList: Actions.getVendorSrmIpAgentList,
    getVendorWardList: Actions.getVendorWardList,
})(AddRoomService
));
